import { FC } from "react";

interface props {
  open?: boolean;
}

export const Loading: FC<props> = (props) => {
  return (
    <dialog open={props.open} className="modal ">
      <div className="modal-box max-w-md md:mx-auto p-3 shadow-none rounded-none h-screen max-h-none bg-[#EFEFEF]">
        <div className="flex flex-col items-center justify-center w-full h-full">
          <span className="loading loading-spinner loading-lg bg-primary" />
        </div>
      </div>
    </dialog>
  );
};
